import axios from 'axios';
import Datasource from '@/domain/business-unit/entity/datasource.entity';
import VariableMetadata from '@/domain/business-unit/entity/variable-metadata.entity';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';

export default class RuleVariablesService {
  public static getVariables(
    businessUnitId: string,
    dataSourceId: string,
  ): Promise<VariableMetadata[]> {
    return axios
      .get(`/api/v1/business-units/${businessUnitId}/data-sources/${dataSourceId}/variables`)
      .then((response: any) => VariableMetadata.ofList(response.data));
  }

  public static refreshVariables(businessUnitId: string, dataSourceId: string): Promise<string[]> {
    return axios
      .post(`/api/v1/business-units/${businessUnitId}/data-sources/${dataSourceId}/variables/refresh`)
      .then((response: any) => response.data);
  }

  public static listDataSources(businessUnitId: string): Promise<Datasource[]> {
    return BusinessUnitService.getDatasources(businessUnitId);
  }
}
